import { View } from './view'

export const ButtonLink = View
